import React, { PureComponent } from "react";
import DialogContainer from "../../containers/DialogContainer";
import { TextField, DialogActions, Button } from "@material-ui/core";
import _ from "lodash";
import { withFormik } from "formik";
import * as Yup from "yup";

class AddStaffDialog extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      validateCalled: false,
      firstname: "",
      lastname: "",
      position: "",
      email: ""
    };
    this.firstnameTextField = null;
    this.setFirstnameTextField = ref => {
      this.firstnameTextField = ref;
    };
    this.focusFirstnameTextField = () => {
      if (this.firstnameTextField) this.firstnameTextField.focus();
    };
  }

  handleChange = name => e => {
    this.setState({
      [name]: e.target.value
    });
  };

  onAddStaff = async () => {
    this.setState({ validateCalled: true })
    await this.props.validateForm()
    if(this.props.isValid){
      let value = _.assign({}, this.props.values);
      let object = {
        name: "staffs",
        value
      };
      this.props.addStaffToState(object);
    }
  };

  onExit = () =>
    this.setState({ firstname: "", lastname: "", position: "", email: "" });

  onEnter = () => {};

  render() {
    const { validateCalled } = this.state;
    const {
      handleChange,
      handleBlur,
      errors,
      values,
      touched,
      isValidating
    } = this.props;
    return (
      <DialogContainer
        open={this.props.open}
        onEntered={this.focusFirstnameTextField}
        onExit={this.onExit}
        title="Add Client Staff"
        contentText={`To add client staff please enter the necessary information. Click "Save" to add Staff`}
        actions={
          <DialogActions>
            <Button color="secondary" onClick={this.props.handleClose}>
              Cancel
            </Button>
            <Button color="primary" onClick={this.onAddStaff}>
              Save
            </Button>
          </DialogActions>
        }
      >
        <TextField
          autoComplete="off"
          inputProps={{
            ref: this.setFirstnameTextField
          }}
          id="firstname"
          helperText={(touched.firstname || validateCalled) && errors.firstname}
          error={(touched.firstname || validateCalled) && errors.firstname}
          value={values.firstname}
          onBlur={handleBlur}
          onChange={handleChange}
          label="Firstname"
          margin="normal"
          fullWidth
          variant="outlined"
        />
        <TextField
          autoComplete="off"
          id="lastname"
          helperText={(touched.lastname || validateCalled) && errors.lastname}
          error={(touched.lastname || validateCalled) && errors.lastname}
          value={values.lastname}
          onBlur={handleBlur}
          onChange={handleChange}
          label="Lastname"
          margin="normal"
          fullWidth
          variant="outlined"
        />
        <TextField
          autoComplete="off"
          id="position"
          helperText={(touched.position || validateCalled) && errors.position}
          error={(touched.position || validateCalled) && errors.position}
          value={values.position}
          onBlur={handleBlur}
          onChange={handleChange}
          label="Position"
          margin="normal"
          fullWidth
          variant="outlined"
        />
        <TextField
          autoComplete="off"
          id="email"
          helperText={(touched.email || validateCalled) && errors.email}
          error={(touched.email || validateCalled) && errors.email}
          value={values.email}
          onBlur={handleBlur}
          onChange={handleChange}
          label="Email address"
          margin="normal"
          fullWidth
          variant="outlined"
        />
      </DialogContainer>
    );
  }
}

export default withFormik({
  mapPropsToValues: props => {
    return {
      firstname: "",
      lastname: "",
      position: "",
      email: ""
    };
  },
  validationSchema: Yup.object().shape({
    firstname: Yup.string().required("Firstname field is required."),
    lastname: Yup.string().required("Lastname field is required."),
    position: Yup.string().required("Position field is required."),
    email: Yup.string()
      .email("Please provide a valid email address.")
      .required("Email address field is required.")
  }),
  validateOnChange: true
})(AddStaffDialog);
